import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
  standalone: false
})

export class SettingComponent {
  setting_data: any;
  id: any;
  event_id: any;
  registration: any;
  unique_mobile: any;
  contact_privacy: any;
  start_reg_from: any;
  send_whatsapp_reg: any;
  send_email: any;
  ticket_print: any;
  baseurl: any;
  reg_url: any;
  whatsapp_url: any = 'https://whatsapp.myappstores.com/api/sendFileWithCaption?token=5f913234e4bd1321ff3c1e59&phone=91[phone]&link=[link]&message=[message]';
  url: any;
  vendor_id: any;
  method: any;
  headers: any;
  body_template: any;
  success_msg: any;
  display_msg: any;
  close_msg: any;
  reg_whatsapp_msg: any;
  private destoryRef = inject(DestroyRef)
  Enable_Whatsapp_Url: boolean = false;

  hostname: any;
  port: any;
  security: any;
  username: any;
  password: any;
  from_email: any;
  title: any;
  email_subject: any;
  email_template: any;
  email_smtp: any;
  isUpdating = false;

  constructor(
    private service: ServicesService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    const User = sessionStorage.getItem('User');
    const eventId = sessionStorage.getItem('Event_ID');
    this.Get_Setting(eventId);

    if (User == 'superadmin' && eventId) {
      this.Enable_Whatsapp_Url = true;
    }
  }



  onUrlChange(value: string) {
    if (this.isUpdating) return;

    this.isUpdating = true;

    if (!value) {
      this.vendor_id = '';
      this.isUpdating = false;
      return;
    }

    const regex = /https:\/\/bluewaba\.com\/api\/([^\/]+)\/contact\/send-template-message/;
    const match = value.match(regex);

    if (match && match[1] && match[1] !== '{vendorID}') {
      this.vendor_id = match[1];
    } else {
      this.vendor_id = '';
    }

    this.isUpdating = false;
  }


  onVendorChange(value: string) {
    if (this.isUpdating) return;

    this.isUpdating = true;

    if (!value) {
      this.url = '';
      this.isUpdating = false;
      return;
    }

    this.url = `https://bluewaba.com/api/${value}/contact/send-template-message`;

    this.isUpdating = false;
  }

  Get_Setting(eventId: any) {
    this.spinner.show();
    this.service.getsetting(eventId).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.setting_data = data.data;

        this.id = this.setting_data[0].id,
          this.event_id = this.setting_data[0].event_id,
          this.registration = this.setting_data[0].registration,
          this.unique_mobile = this.setting_data[0].unique_mobile,
          this.contact_privacy = this.setting_data[0].contact_privacy,
          this.start_reg_from = this.setting_data[0].start_reg_from,
          this.success_msg = this.setting_data[0].success_msg,
          this.close_msg = this.setting_data[0].close_msg,
          this.display_msg = this.setting_data[0].display_msg,
          this.send_email = this.setting_data[0].send_email,
          this.send_whatsapp_reg = this.setting_data[0].send_whatsapp_reg,
          this.reg_whatsapp_msg = this.setting_data[0].reg_whatsapp_msg,
          this.ticket_print = this.setting_data[0].ticket_print,
          this.reg_url = this.setting_data[0].reg_url,
          this.url = this.setting_data[0].url,
          this.vendor_id = this.setting_data[0].vendor_id,
          this.method = this.setting_data[0].method,
          this.headers = this.setting_data[0].headers,
          this.body_template = this.setting_data[0].body_template,
          this.email_subject = this.setting_data[0].email_subject,
          this.email_template = this.setting_data[0].email_template,
        this.whatsapp_url = this.setting_data[0].whatsapp_url ? this.setting_data[0].whatsapp_url : 'https://whatsapp.myappstores.com/api/sendFileWithCaption?token=5f913234e4bd1321ff3c1e59&phone=91[phone]&link=[link]&message=[message]',

          // Parsing the email_smtp string using URLSearchParams
          this.email_smtp = this.setting_data[0].email_smtp;
        if (this.email_smtp) {
          const params = new URLSearchParams(this.email_smtp);

          // Retrieve values from URLSearchParams
          this.hostname = params.get('hostname') || '';
          this.port = params.get('port') || '';
          this.security = params.get('security') || '';
          this.username = params.get('username') || '';
          this.password = params.get('password') || '';
          this.from_email = params.get('from_email') || '';
          this.title = params.get('title') || '';

        }
        this.spinner.hide();
      })
  }

  Update_setting() {
    // Combine the fields into a single string
    const email_smtp = `hostname=${this.hostname}&port=${this.port}&security=${this.security}&username=${this.username}&password=${this.password}&from_email=${this.from_email}&title=${this.title}`;
    const setting = {
      registration: this.registration,
      unique_mobile: this.unique_mobile,
      contact_privacy: this.contact_privacy,
      start_reg_from: this.start_reg_from,
      success_msg: this.success_msg,
      display_msg: this.display_msg,
      close_msg: this.close_msg,
      send_email: this.send_email,
      send_whatsapp_reg: this.send_whatsapp_reg,
      reg_whatsapp_msg: this.reg_whatsapp_msg,
      reg_url: this.reg_url,
      ticket_print: this.ticket_print,
      whatsapp_url: this.whatsapp_url,
      url: this.url,
      vendor_id: this.vendor_id,
      method: this.method,
      headers: this.headers,
      body_template: this.body_template,
      email_smtp: email_smtp,
      email_subject: this.email_subject,
      email_template: this.email_template
    }


    this.service.edit_setting(setting).subscribe(
      (data: any) => {
        this.toastr.success("Setting Updated Succesfully");
      }
    )
  }

  copyLink() {
    navigator.clipboard.writeText(this.reg_url).then(() => {
      this.toastr.success('Link copied to clipboard')
      // Optionally, provide feedback to the user
    }).catch(err => {
      console.error('Failed to copy link: ', err);
    });
  }

  goToLink() {
    window.open(this.reg_url, '_blank');
  }

}
